import { apiEndpoints } from 'settings/_apiSettings'
import axios from 'settings/axios'

export const isEmailAvailable = async (email: string): Promise<void> => {

  const endpoint = apiEndpoints.PATIENTS_BY_EMAIL(email)

  return axios.head(endpoint)
}
